<div class="event-filter-tabs" role="tablist" [ngStyle]="customStyles">
  <button
    type="button"
    class="tab"
    role="tab"
    [attr.aria-selected]="selected() === 'left'"
    [class.active]="selected() === 'left'"
    (click)="select('left')"
  >
    {{ leftLabel }}
    @if (leftCount !== undefined) {
    <span>({{ leftCount }})</span>
    }
  </button>
  <button
    type="button"
    class="tab"
    role="tab"
    [attr.aria-selected]="selected() === 'right'"
    [class.active]="selected() === 'right'"
    (click)="select('right')"
  >
    {{ rightLabel }}
    @if (rightCount !== undefined) {
    <span>({{ rightCount }})</span>
    }
  </button>
</div>
